module.exports = __webpack_public_path__ + "img/18.104.A.b9698cc1.png";